export default function () {
  return {
    list: [],
    current: null,

    listLoading: false,
    saveLoading: false,
  };
}
